import { logNavInteraction, NAV_ELEMENT_TYPES, NAV_ACTIONS } from 'utils';


export default function NavPromoCard({
  image, link, label, gradient, placeholder = false, closeMenu, navInteractionConfig  }) { 

  const handleClick = function(navInteractionConfig) {
    if (closeMenu) closeMenu();
    logNavInteraction(navInteractionConfig);
  };

  {/* Still renders to preserve layout, but fully hidden */}
  if (placeholder) {
    return (
      <div className="tw-invisible tw-aspect-[1.7] 
          tw-h-auto 
          tw-w-full 
          tw-max-w-[387px]
          tw-overflow-hidden
          tw-rounded-8 
          tw-bg-cover 
          tw-bg-center 
          tw-py-16 
          tw-pl-[13px] 
          tw-pr-[11px]">
        <div className="tw-aspect-square tw-w-full tw-rounded-8 tw-bg-gray-200" />
      </div>
    );
  }

  return (
    <a
      href={link}
      className='tw-group tw-block tw-h-auto'
      onClick={() => handleClick({
        ...navInteractionConfig,
        elementType: NAV_ELEMENT_TYPES.IMAGE, 
        text: label, 
        action: NAV_ACTIONS.LINK,
      })}   
    >
      <div 
        className="
          tw-relative 
          tw-aspect-[1.7] 
          tw-h-auto 
          tw-w-full 
          tw-max-w-[387px]
          tw-overflow-hidden
          tw-rounded-8 
          tw-bg-cover 
          tw-bg-center 
          tw-py-16 
          tw-pl-[13px] 
          tw-pr-[11px]
        " 
        style={{ backgroundImage: `url(${image})` }}
      >
        {/* Gradient Overlay */}
        { gradient && 
          <div 
            className="tw-absolute tw-inset-0" 
            style={{ background: gradient }}
          />
        }

        <div className='tw-relative tw-flex tw-justify-between tw-gap-8'>  
          <p
            className='tw-text-12 tw-font-semibold tw-capitalize tw-leading-14 tw-text-white desktop:tw-text-16'
            dangerouslySetInnerHTML={{ __html: label.replace(/:/g, ':<br />') }}
          ></p>
          <button className='tw-h-fit tw-whitespace-nowrap tw-rounded-4 tw-border tw-border-solid tw-border-white tw-px-20 tw-py-8 tw-text-18 tw-font-bold tw-leading-16 tw-text-white group-hover:tw-bg-white group-hover:tw-text-[#3F4443] focus:tw-border-[#005EB8] active:tw-border-[#131716] active:tw-bg-[#6C7271] active:tw-text-[#131716]'>Shop Now</button>  </div>
        </div>
    </a>
  );
}
